import { GooglePlayLogo } from "@phosphor-icons/react";

export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=app.nestled6035650c&pcampaignid=web_share";

/**
 * Official-style "Get it on Google Play" black badge.
 * Variants:
 *   - size="md" (default) — full badge with "GET IT ON / Google Play" stacked text
 *   - size="sm" — compact height for tight nav slots
 *   - size="lg" — hero-sized
 */
export default function GooglePlayBadge({ size = "md", className = "", dataTestId = "google-play-badge" }) {
  const heights = {
    sm: "h-9",
    md: "h-12",
    lg: "h-14",
  };
  const iconSizes = { sm: 18, md: 24, lg: 28 };
  const topText = { sm: "text-[8px]", md: "text-[9px]", lg: "text-[10px]" };
  const bottomText = { sm: "text-sm", md: "text-base", lg: "text-lg" };
  const padX = { sm: "pl-2.5 pr-3.5", md: "pl-3.5 pr-5", lg: "pl-4 pr-6" };

  return (
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={dataTestId}
      className={`inline-flex items-center gap-2.5 ${heights[size]} ${padX[size]} rounded-xl bg-stoneink-900 hover:bg-stoneink-900/90 text-white transition-all active:scale-[0.98] shadow-ambient hover:shadow-hover ${className}`}
    >
      <GooglePlayLogo weight="fill" size={iconSizes[size]} className="text-white shrink-0" />
      <span className="text-left leading-tight">
        <span className={`block ${topText[size]} uppercase tracking-[0.14em] opacity-80`}>Get it on</span>
        <span className={`block ${bottomText[size]} font-semibold -mt-0.5`}>Google Play</span>
      </span>
    </a>
  );
}
